import { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  size?: string | number;
}

export default function Star({ size = 84, ...props }: Props) {
  const width = Number(size);
  const height = (width / 84) * 112;

  return (
    <svg width={width} height={height} {...props} viewBox="0 0 84 112" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M42 0C42 29.5568 24.5748 56 0 56C24.5748 56 42 82.4451 42 112C42 82.4451 59.4252 56 84 56C59.4252 56 42 29.5568 42 0Z" fill="#05A88F" />
    </svg>
  );
}